export default __webpack_public_path__ + "static/media/screen6.09dc4b2e.png";